// 导出配置的路由器
export default [{
	path: '/maintenanceCenter',
	component: () => import('@/layout/index'),
	redirect: 'maintenanceCenter/controlManage',
	meta: {
		title: '运维中心',
		icon: 'icon-yunwei',
		perms: ['bee:ops']
	},
	children: [/*{
			path: 'controlManage',
			component: () => import('@/module/maintenanceCenter/page/remoteControl/controlManage.vue'),
			meta: {
				icon: 'icon-caozuo',
				title: '远程控制',
				perms: ['bee:ops:commandRecord']
			}
		},*/
/*		{
			path: 'customerPraiseManage',
			component: () => import('@/module/maintenanceCenter/page/customerPraise/manage.vue'),
			meta: {
				icon: 'icon-pingjia',
				title: '订单评价',
				perms: ['bee:ops:customerPraise']
			}
		},*/
		{
			path: 'faultRepairAdvice',
			component: () => import('@/module/maintenanceCenter/page/faultRepair/manage.vue'),
			meta: {
				icon: 'icon-wenti',
				title: '故障报修',
				perms: ['bee:ops:faultRepair']
			}
		},
/*		{
			path: 'saleServiceManage',
			component: () => import('@/module/maintenanceCenter/page/saleService/manage.vue'),
			meta: {
				icon: 'icon-shouhou1',
				title: '售后服务',
				perms: ['bee:ops:saleService']
			}
		},*/
/*		{
			path: 'monitoringLog',
			component: () => import('@/module/maintenanceCenter/page/monitoringLog/manage.vue'),
			meta: {
				icon: 'icon-yunwei',
				title: '运维监控',
				perms: ['bee:ops:monitoringLog']
			}
		}*/
	]
}]



// WEBPACK FOOTER //
// ./src/module/maintenanceCenter/router/index.js